// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchHeader":"vX","sortWrapper":"wX","shortCount":"xX","fullCount":"yX","countWrapper":"zX"};